/** @format */

import React, { useState, useEffect, useCallback } from "react";
// import {csc} from "country-state-city";
import Input from "../../extra/Input";
import Button from "../../extra/Button";
import LocationPicker from "../../extra/LocationPicker";
import { connect, useSelector } from "react-redux";
import { createSeller, updateSeller } from "../../store/seller/seller.action";
import { useLocation, useNavigate } from "react-router-dom";
import { baseURL, secretKey } from "../../../util/config";

const AddSeller = (props) => {
	const state = useLocation();
	const [mongoId, setMongoId] = useState("");
	const [firstName, setFirstName] = useState("");
	const [lastName, setLastName] = useState("");
	const [mobileNumber, setMobileNumber] = useState("");
	const [gender, setGender] = useState("");
	const [email, setEmail] = useState("");
	const [password, setPassword] = useState("");
	const [confirmPassword, setConfirmPassword] = useState("");
	const [image, setImage] = useState([]);
	const [imagePath, setImagePath] = useState("");
	const [address, setAddress] = useState("");
	const [landmark, setLandmark] = useState("");
	const [pinCode, setPinCode] = useState("");
	const [businessName, setBusinessName] = useState("");
	const [businessTag, setBusinessTag] = useState("");
	const [bankName, setBankName] = useState("");
	const [bankCode, setBankCode] = useState("");
	const [bankBusinessName, setBankBusinessName] = useState("");
	const [accountNumber, setAccountNumber] = useState("");
	const [accountName, setAccountName] = useState("");
	const [IFSCCode, setIFSCCode] = useState("");
	const [branchName, setBranchName] = useState("");
	const [countries, setCountries] = useState("Nigeria");
	const [states, setStates] = useState("");
	const [cities, setCities] = useState("");

	// Paystack bank list & account verification
	const [bankList, setBankList] = useState([]);
	const [bankSearch, setBankSearch] = useState("");
	const [showBankDropdown, setShowBankDropdown] = useState(false);
	const [verifyingAccount, setVerifyingAccount] = useState(false);
	const [accountVerified, setAccountVerified] = useState(false);
	const [verifyError, setVerifyError] = useState("");

	// const [selectedCountry, setSelectedCountry] = useState("");
	// const [selectedState, setSelectedState] = useState("");
	// const [selectedCity, setSelectedCity] = useState("");

	const [error, setError] = useState({
		firstName: "",
		lastName: "",
		mobileNumber: "",
		gender: "",
		email: "",
		password: "",
		confirmPassword: "",
		imagePath: "",
		address: "",
		landmark: "",
		countries: "",
		states: "",
		cities: "",
		pinCode: "",
		businessName: "",
		businessTag: "",
		bankName: "",
		bankBusinessName: "",
		accountNumber: "",
		IFSCCode: "",
		branchName: "",
	});
	const navigate = useNavigate();
	const handleUploadImage = (e) => {
		setImage(e.target.files[0]);
		setImagePath(URL.createObjectURL(e.target.files[0]));
	};

	const handleCancle = () => {
		navigate("/admin/seller");
	};

	// Fetch Paystack bank list on mount
	useEffect(() => {
		const fetchBanks = async () => {
			try {
				const res = await fetch(`${baseURL}paystack/banks?currency=NGN&perPage=100`, {
					headers: { key: secretKey, Authorization: sessionStorage.getItem("token") || "" },
				});
				const data = await res.json();
				if (data.status && data.banks) {
					setBankList(data.banks.sort((a, b) => a.name.localeCompare(b.name)));
				}
			} catch (err) {
				console.error("Failed to fetch Paystack banks:", err);
			}
		};
		fetchBanks();
	}, []);

	// Verify account when both bank and account number are present
	const verifyAccount = useCallback(async (accNum, bCode) => {
		if (!accNum || accNum.length < 10 || !bCode) {
			setAccountVerified(false);
			setAccountName("");
			setVerifyError("");
			return;
		}
		setVerifyingAccount(true);
		setVerifyError("");
		setAccountVerified(false);
		try {
			const res = await fetch(`${baseURL}paystack/resolve-account?account_number=${accNum}&bank_code=${bCode}`, {
				headers: { key: secretKey, Authorization: sessionStorage.getItem("token") || "" },
			});
			const data = await res.json();
			if (data.status && data.data?.account_name) {
				setAccountName(data.data.account_name);
				setAccountVerified(true);
				setVerifyError("");
			} else {
				setAccountName("");
				setAccountVerified(false);
				setVerifyError(data.message || "Could not verify account");
			}
		} catch (err) {
			setAccountName("");
			setAccountVerified(false);
			setVerifyError("Verification failed");
		} finally {
			setVerifyingAccount(false);
		}
	}, []);

	const handleSelectBank = (bank) => {
		setBankName(bank.name);
		setBankCode(bank.code);
		setBankSearch(bank.name);
		setShowBankDropdown(false);
		setError({ ...error, bankName: "" });
		// Auto-verify if account number is present
		if (accountNumber && accountNumber.length >= 10) {
			verifyAccount(accountNumber, bank.code);
		}
	};

	const filteredBanks = bankList.filter((b) => b.name.toLowerCase().includes(bankSearch.toLowerCase()));

	useEffect(() => {
		if (state) {
			setMongoId(state?.state?._id);
			setFirstName(state?.state?.firstName);
			setLastName(state?.state?.lastName);
			setMobileNumber(state?.state?.mobileNumber);
			setGender(state?.state?.gender);
			setEmail(state?.state?.email);
			setPassword(state?.state?.password);
			setConfirmPassword(state?.state?.password);
			setImagePath(state?.state?.image);
			setAddress(state?.state?.address?.address);
			setLandmark(state?.state?.address?.landMark);
			setPinCode(state?.state?.address?.pinCode);
			setBusinessName(state?.state?.businessName);
			setBusinessTag(state?.state?.businessTag);
			setBankName(state?.state?.bankDetails?.bankName || "");
			setBankCode(state?.state?.bankDetails?.bankCode || "");
			setBankSearch(state?.state?.bankDetails?.bankName || "");
			setBankBusinessName(state?.state?.bankDetails?.bankBusinessName || "");
			setAccountNumber(state?.state?.bankDetails?.accountNumber || "");
			setAccountName(state?.state?.bankDetails?.accountName || "");
			if (state?.state?.bankDetails?.accountName) setAccountVerified(true);
			setIFSCCode(state?.state?.bankDetails?.IFSCCode || "");
			setBranchName(state?.state?.bankDetails?.branchName || "");
			setCountries(state?.state?.address?.country || "Nigeria");
			setStates(state?.state?.address?.state);
			setCities(state?.state?.address?.city);
		}
	}, [state]);

	const isEditing = !!mongoId;

	const handleSubmit = () => {
		const needsPassword = !isEditing;
		if (!firstName || !lastName || !mobileNumber || !image || mobileNumber?.length < 0 || mobileNumber?.length > 10 || !email || (needsPassword && (!password || !confirmPassword || password !== confirmPassword)) || !gender || !address || !landmark || !cities || !states || !countries || !pinCode || pinCode < 0 || !businessName || !businessTag || !bankName || !bankBusinessName || !accountNumber || accountNumber < 0 || !IFSCCode || !branchName) {
			let error = {};
			if (!firstName) error.firstName = "First Name Is Required ";
			if (!lastName) error.lastName = "Last Name Is Required ";
			if (!mobileNumber) error.mobileNumber = "Mobile Number Is Required ";
			if (mobileNumber?.length > 10) error.mobileNumber = "Invalid Mobile Number...";
			if (image?.length === 0 || !imagePath) error.image = "Image is required!";
			if (!email) error.email = "Email Is Required ";
			if (needsPassword && !password) error.password = "Password Is Required ";
			if (needsPassword && password !== confirmPassword) error.confirmPassword = "Confirm Password Is doesn't match to Password ";
			if (!gender) error.gender = "Gender Is Required ";
			if (!address) error.address = "Address Is Required ";
			if (!landmark) error.landmark = "Landmark Is Required ";
			if (!cities) error.cities = "city Is Required ";
			if (!states) error.states = "State Is Required ";
			if (!countries) error.countries = "Country Is Required ";
			if (!pinCode) error.pinCode = "PinCode Is Required ";
			if (pinCode < 0 || pinCode <= 5) error.pinCode = "Invalid PinCode";
			if (!businessName) error.businessName = "Business Name Is Required ";
			if (!businessTag) error.businessTag = "Business Tag Is Required ";
			if (!bankBusinessName) error.bankBusinessName = "Bank Business Name Is Required ";
			if (!bankName) error.bankName = "Bank Name Is Required ";
			if (!accountNumber) error.accountNumber = "Account Number Is Required ";
			if (accountNumber < 0) error.accountNumber = "Invalid Account Number !... ";
			if (!IFSCCode) error.IFSCCode = "IFSC Code Is Required ";
			if (!branchName) error.branchName = "Branch Name Is Required ";
			return setError({ ...error });
		} else {
			const formData = new FormData();

			formData.append("firstName", firstName);
			formData.append("lastName", lastName);
			formData.append("mobileNumber", mobileNumber);
			formData.append("email", email);
			if (!isEditing) formData.append("password", confirmPassword);
			formData.append("image", image);
			formData.append("gender", gender);
			formData.append("landMark", landmark);
			formData.append("businessName", businessName);
			formData.append("businessTag", businessTag);
			formData.append("bankName", bankName);
			formData.append("bankCode", bankCode);
			formData.append("bankBusinessName", bankBusinessName);
			formData.append("accountNumber", accountNumber);
			formData.append("accountName", accountName);
			formData.append("IFSCCode", IFSCCode);
			formData.append("branchName", branchName);
			formData.append("country", countries);
			formData.append("state", states);
			formData.append("city", cities);
			formData.append("pinCode", pinCode);
			formData.append("address", address);

			if (!mongoId) {
				props.createSeller(formData);
			} else {
				props.updateSeller(formData, mongoId);
			}

			setTimeout(() => {
				navigate("/admin/seller");
			}, 3800);
		}
	};

	return (
		<>
			<div className='mainSellerDialog'>
				<div className='sellerDialog'>
					<div className='sellerHeader primeHeader'>
						<div className='row'>
							<div className='col-10'></div>
							<div className='col-2 text-end'></div>
							<div className='col-6'></div>
						</div>
					</div>
					<div className='sellerMain' style={{ margin: "10px 18px" }}>
						<div className='card'>
							<div className='card-body'>
								<div className='sellerDetail pt-3'>
									<div className='row'>
										<div className='col-12'>
											<h2 className='fw-bolder mb-4'>Seller Information</h2>
										</div>
										<div className='col-md-6 col-12'>
											<Input
												label={`First Name`}
												placeholder={`First Name`}
												id={`firstName`}
												type={`text`}
												value={firstName}
												errorMessage={error.firstName && error.firstName}
												onChange={(e) => {
													setFirstName(e.target.value);
													if (!e.target.value) {
														return setError({
															...error,
															firstName: `First Name Is Required`,
														});
													} else {
														return setError({
															...error,
															firstName: "",
														});
													}
												}}
											/>
										</div>
										<div className='col-md-6 col-12'>
											<Input
												label={`Last Name`}
												placeholder={`last Name`}
												id={`lastName`}
												type={`text`}
												value={lastName}
												errorMessage={error.lastName && error.lastName}
												onChange={(e) => {
													setLastName(e.target.value);
													if (!e.target.value) {
														return setError({
															...error,
															lastName: `LastName Is Required`,
														});
													} else {
														return setError({
															...error,
															lastName: "",
														});
													}
												}}
											/>
										</div>
										<div className='col-md-6 col-12'>
											<Input
												label={`Mobile Number`}
												placeholder={`Mobile Number`}
												id={`mobileNumber`}
												type={`number`}
												value={mobileNumber}
												errorMessage={error.mobileNumber && error.mobileNumber}
												onChange={(e) => {
													setMobileNumber(e.target.value);
													if (!e.target.value) {
														return setError({
															...error,
															mobileNumber: `Mobile Number Is Required`,
														});
													} else {
														return setError({
															...error,
															mobileNumber: "",
														});
													}
												}}
											/>
										</div>
										<div className='col-md-6 col-12'>
											<Input
												label={`Email`}
												placeholder={`Email`}
												id={`email`}
												type={`text`}
												value={email}
												errorMessage={error.email && error.email}
												onChange={(e) => {
													setEmail(e.target.value);
													if (!e.target.value) {
														return setError({
															...error,
															email: `Email Is Required`,
														});
													} else {
														return setError({
															...error,
															email: "",
														});
													}
												}}
											/>
										</div>

										{!isEditing && (
											<div className='col-md-6 col-12'>
												<Input
													label={`Password`}
													placeholder={`Password`}
													id={`password`}
													type={`password`}
													value={password}
													errorMessage={error.password && error.password}
													onChange={(e) => {
														setPassword(e.target.value);
														if (!e.target.value) {
															return setError({
																...error,
																password: `Password Is Required`,
															});
														} else {
															return setError({
																...error,
																password: "",
															});
														}
													}}
												/>
											</div>
										)}
										{!isEditing && (
											<div className='col-md-6 col-12'>
												<Input
													label={`Confirm Password`}
													placeholder={`Confirm Password`}
													id={`confirmPassword`}
													type={`password`}
													value={confirmPassword}
													errorMessage={error.confirmPassword && error.confirmPassword}
													onChange={(e) => {
														setConfirmPassword(e.target.value);
														if (!e.target.value) {
															return setError({
																...error,
																confirmPassword: `Confirm Password Is Required`,
															});
														} else {
															return setError({
																...error,
																confirmPassword: "",
															});
														}
													}}
												/>
											</div>
										)}
										<div className='col-md-6 col-12'>
											<Input label={`Image`} id={`sellerImage`} type={`file`} accept={`image/*`} errorMessage={error.image && error.image} onChange={(e) => handleUploadImage(e)} />
											{imagePath && (
												<>
													<img
														src={imagePath}
														className='ms-2 mb-4'
														style={{
															width: "70px",
															height: "70px",
															borderRadius: "10px",
														}}
														alt=''
														srcset=''
													/>
												</>
											)}
										</div>

										<div className='col-md-6 col-12'>
											<div className='prime-input mb-2'>
												<label className='mb-3'> Select Gender </label>
											</div>
											<div className='d-flex align-items-center'>
												<Input
													label={`Male`}
													name={`gender`}
													id={`male`}
													type={`radio`}
													value={`male`}
													checked={(gender == "male" || gender == "Male") && true}
													newClass={`me-3`}
													onChange={(e) => {
														setGender(e.target.value);
														if (!e.target.value) {
															return setError({
																...error,
																gender: `Gender Is Required`,
															});
														} else {
															return setError({
																...error,
																gender: "",
															});
														}
													}}
												/>
												<Input
													label={`Female`}
													name={`gender`}
													id={`female`}
													type={`radio`}
													value={`female`}
													checked={(gender == "female" || gender == "Female") && true}
													onChange={(e) => {
														setGender(e.target.value);
														if (!e.target.value) {
															return setError({
																...error,
																gender: `Gender Is Required`,
															});
														} else {
															return setError({
																...error,
																gender: "",
															});
														}
													}}
												/>
											</div>
											{error.gender && (
												<>
													<p className='errorMessage'>{error.gender}</p>
												</>
											)}
										</div>
									</div>
									<div className='row'>
										<div className='col-12'>
											<h2 className='fw-bolder my-4'>Address Information</h2>
										</div>
										<div className='col-md-6 col-12'>
											<Input
												label={`Address`}
												placeholder={`Address`}
												id={`address`}
												type={`text`}
												value={address}
												errorMessage={error.address && error.address}
												onChange={(e) => {
													setAddress(e.target.value);
													if (!e.target.value) {
														return setError({
															...error,
															address: `Address Is Required`,
														});
													} else {
														return setError({
															...error,
															address: "",
														});
													}
												}}
											/>
										</div>
										<div className='col-md-6 col-12'>
											<Input
												label={`Landmark`}
												placeholder={`Landmark`}
												id={`landmark`}
												type={`text`}
												value={landmark}
												errorMessage={error.landmark && error.landmark}
												onChange={(e) => {
													setLandmark(e.target.value);
													if (!e.target.value) {
														return setError({
															...error,
															landmark: `Landmark Is Required`,
														});
													} else {
														return setError({
															...error,
															landmark: "",
														});
													}
												}}
											/>
										</div>
										{/* Location Picker - Country, State, City dropdowns */}
										<LocationPicker
											country={countries}
											state={states}
											city={cities}
											onCountryChange={(val) => {
												setCountries(val);
												setError({ ...error, countries: "" });
											}}
											onStateChange={(val) => {
												setStates(val);
												setCities(""); // Reset city when state changes
												setError({ ...error, states: "" });
											}}
											onCityChange={(val) => {
												setCities(val);
												setError({ ...error, cities: "" });
											}}
											errors={{
												country: error.countries,
												state: error.states,
												city: error.cities,
											}}
										/>

										<div className='col-md-6 col-12'>
											<Input
												label={`Pincode`}
												placeholder={`Pincode`}
												id={`pinCode`}
												type={`number`}
												value={pinCode}
												errorMessage={error.pinCode && error.pinCode}
												onChange={(e) => {
													setPinCode(e.target.value);
													if (!e.target.value) {
														return setError({
															...error,
															pinCode: `PinCode Is Required`,
														});
													} else {
														return setError({
															...error,
															pinCode: "",
														});
													}
												}}
											/>
										</div>
									</div>
									<div className='row'>
										<div className='col-12'>
											<h2 className='fw-bolder my-4'>Account Details</h2>
										</div>
										<div className='col-md-6 col-12'>
											<Input
												label={`Business Name`}
												placeholder={`Business Name`}
												id={`businessName`}
												type={`text`}
												value={businessName}
												errorMessage={error.businessName && error.businessName}
												onChange={(e) => {
													setBusinessName(e.target.value);
													if (!e.target.value) {
														return setError({
															...error,
															businessName: `Business Name Is Required`,
														});
													} else {
														return setError({
															...error,
															businessName: "",
														});
													}
												}}
											/>
										</div>
										<div className='col-md-6 col-12'>
											<Input
												label={`Bussiness Tag`}
												placeholder={`Business Tag`}
												id={`Bussinesstage`}
												type={`text`}
												value={businessTag}
												errorMessage={error.businessTag && error.businessTag}
												onChange={(e) => {
													setBusinessTag(e.target.value);
													if (!e.target.value) {
														return setError({
															...error,
															businessTag: `Bussiness Tage Is Required`,
														});
													} else {
														return setError({
															...error,
															businessTag: "",
														});
													}
												}}
											/>
										</div>
										<div className='col-md-6 col-12'>
											<Input
												label={`Bank Bussiness Name`}
												placeholder={`Bank Bussiness Name`}
												id={`Bank Bussiness Name`}
												type={`text`}
												value={bankBusinessName}
												errorMessage={error.bankBusinessName && error.bankBusinessName}
												onChange={(e) => {
													setBankBusinessName(e.target.value);
													if (!e.target.value) {
														return setError({
															...error,
															bankBusinessName: `Bank Bussiness Name Is Required`,
														});
													} else {
														return setError({
															...error,
															bankBusinessName: "",
														});
													}
												}}
											/>
										</div>
										<div className='col-md-6 col-12'>
											<div style={{ position: "relative" }}>
												<label className='float-left inputLabel' style={{ fontSize: "14px", fontWeight: "500", marginBottom: "5px" }}>
													Bank Name
												</label>
												<input
													type='text'
													className='form-input'
													placeholder='Search bank...'
													value={bankSearch}
													style={{
														width: "100%",
														padding: "10px 14px",
														borderRadius: "10px",
														border: error.bankName ? "1px solid red" : "1px solid #e0e0e0",
														fontSize: "14px",
														outline: "none",
														backgroundColor: "#fff",
													}}
													onFocus={() => setShowBankDropdown(true)}
													onChange={(e) => {
														setBankSearch(e.target.value);
														setShowBankDropdown(true);
														if (!e.target.value) {
															setBankName("");
															setBankCode("");
															setAccountVerified(false);
															setAccountName("");
															setError({ ...error, bankName: "Bank Name Is Required" });
														}
													}}
												/>
												{error.bankName && <span style={{ color: "red", fontSize: "12px" }}>{error.bankName}</span>}
												{showBankDropdown && filteredBanks.length > 0 && (
													<div
														style={{
															position: "absolute",
															top: "100%",
															left: 0,
															right: 0,
															maxHeight: "200px",
															overflowY: "auto",
															backgroundColor: "#fff",
															border: "1px solid #e0e0e0",
															borderRadius: "8px",
															zIndex: 999,
															boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
														}}>
														{filteredBanks.map((bank) => (
															<div
																key={bank.code}
																onClick={() => handleSelectBank(bank)}
																style={{
																	padding: "10px 14px",
																	cursor: "pointer",
																	fontSize: "14px",
																	borderBottom: "1px solid #f0f0f0",
																	backgroundColor: bankCode === bank.code ? "#fff3ee" : "#fff",
																}}>
																{bank.name}
															</div>
														))}
													</div>
												)}
												{showBankDropdown && <div style={{ position: "fixed", top: 0, left: 0, right: 0, bottom: 0, zIndex: 998 }} onClick={() => setShowBankDropdown(false)} />}
											</div>
										</div>

										<div className='col-md-6 col-12'>
											<Input
												label={`Account Number`}
												placeholder={`Account Number (10 digits)`}
												id={`accountNumber`}
												type={`text`}
												value={accountNumber}
												errorMessage={error.accountNumber && error.accountNumber}
												onChange={(e) => {
													const val = e.target.value.replace(/\D/g, "").slice(0, 10);
													setAccountNumber(val);
													setAccountVerified(false);
													setAccountName("");
													setVerifyError("");
													if (!val) {
														return setError({
															...error,
															accountNumber: `Account Number Is Required`,
														});
													} else {
														setError({ ...error, accountNumber: "" });
													}
													// Auto-verify when 10 digits and bank is selected
													if (val.length === 10 && bankCode) {
														verifyAccount(val, bankCode);
													}
												}}
											/>
											{verifyingAccount && (
												<div style={{ display: "flex", alignItems: "center", gap: "6px", marginTop: "-8px", marginBottom: "8px" }}>
													<div className='spinner-border spinner-border-sm text-warning' role='status' />
													<span style={{ fontSize: "13px", color: "#888" }}>Verifying account...</span>
												</div>
											)}
											{accountVerified && accountName && (
												<div style={{ display: "flex", alignItems: "center", gap: "6px", marginTop: "-8px", marginBottom: "8px", padding: "6px 10px", backgroundColor: "#e8f5e9", borderRadius: "6px" }}>
													<span style={{ color: "#2e7d32", fontSize: "16px" }}>✓</span>
													<span style={{ fontSize: "13px", color: "#2e7d32", fontWeight: "600" }}>{accountName}</span>
												</div>
											)}
											{verifyError && !verifyingAccount && (
												<div style={{ marginTop: "-8px", marginBottom: "8px", padding: "6px 10px", backgroundColor: "#fbe9e7", borderRadius: "6px" }}>
													<span style={{ fontSize: "13px", color: "#c62828" }}>✗ {verifyError}</span>
												</div>
											)}
										</div>
										<div className='col-md-6 col-12'>
											<Input
												label={`Branch Name`}
												placeholder={`Branch Name`}
												id={`branchName`}
												type={`branchName`}
												value={branchName}
												errorMessage={error.branchName && error.branchName}
												onChange={(e) => {
													setBranchName(e.target.value);
													if (!e.target.value) {
														return setError({
															...error,
															branchName: `Branch Name Is Required`,
														});
													} else {
														return setError({
															...error,
															branchName: "",
														});
													}
												}}
											/>
										</div>
										<div className='col-md-6 col-12'>
											<Input
												label={`IFSC Code`}
												placeholder={`IFSC Code`}
												id={`IFSCCode`}
												type={`text`}
												value={IFSCCode}
												errorMessage={error.IFSCCode && error.IFSCCode}
												onChange={(e) => {
													setIFSCCode(e.target.value);
													if (!e.target.value) {
														return setError({
															...error,
															IFSCCode: `IFSCCode Is Required`,
														});
													} else {
														return setError({
															...error,
															IFSCCode: "",
														});
													}
												}}
											/>
										</div>
									</div>
									<div className='row'>
										<div className='col-12 d-flex justify-content-end'>
											<Button btnName={`Close`} btnColor='myCustomButton' style={{ borderRadius: "8px", width: "80px", margin: "2px" }} onClick={handleCancle} />
											<Button btnColor={`btnBlackPrime text-light`} style={{ borderRadius: "8px", width: "80px", margin: "2px" }} newClass={`me-2`} btnName={`Submit`} onClick={handleSubmit} />
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div className='sellerFooter primeFooter'></div>
				</div>
			</div>
		</>
	);
};

export default connect(null, { createSeller, updateSeller })(AddSeller);
